import React, { PureComponent } from "react";
import SalesSpendingChart from "./charts/sales-spending";
import HelpIconButtonWithTooltip from "../../../ui-building-blocks/icons/HelpIconButtonWithTooltip";

class SalesSpending extends PureComponent {
  getDataValue(team_id, key) {
    const { data } = this.props;

    if (!(team_id in data)) {
      return 0;
    }

    if (!(key in data[team_id])) {
      return 0;
    }

    return data[team_id][key] || 0;
  }

  get directSalesSpend() {
    const { teams } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      data.push({
        name: teams[team_id],
        value: this.getDataValue(team_id, "Direct Sales Spend")
      });
    });

    return data;
  }

  get distributionSpend() {
    const { teams } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      data.push({
        name: teams[team_id],
        value: this.getDataValue(team_id, "Distribution Spend")
      });
    });

    return data;
  }

  render() {
    const { teams } = this.props;

    return (
      <div className="row m-0 mt-20">
        <div className="bg-white p-30" style={{ height: 318 }}>
          <h5>
            SALES SPENDING
            <HelpIconButtonWithTooltip
              category="Sales Spending"
              tooltipContent="This section highlights where you are spending to get sales (i.e. Direct Sales vs. Distributors).  Direct Sales are employees of the firm whereas distributors are 3rd parties."
              iconSize="sm"
            />
          </h5>
          <hr></hr>
          <div className="row mt-30">
            <div className="col-md-12 col-xs-12">
              <SalesSpendingChart
                data1={this.directSalesSpend}
                data2={this.distributionSpend}
                teams={teams}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SalesSpending;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/competitive/sales-spending.js